module.exports = __webpack_public_path__ + "assets/images/01B.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01B.png
// module id = 1252
// module chunks = 1